const HERE = '8A2g5AjfRMpTn59J9SB0m_AWBgO6B0lzzGtNsArwCt4';
const H_DATA_ID = 'pO2YTR8X'
const H_DATA = 'AKkxwrw0T9KZYZQ2NmVRigA'
const LINZ = '07c372d6ebee4ab393bfc9b47ead5e63';

module.exports = {
    HERE,
    H_DATA_ID,
    H_DATA,
    LINZ
}